// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
Development Ribbon
========================================================================== */
.ribbon {
  background-color: rgba(170, 0, 0, 0.5);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: absolute;
  top: 40px;
  white-space: nowrap;
  width: 15em;
  z-index: 99999;
  pointer-events: none;
  opacity: 0.75;
}
.ribbon a {
  color: #fff;
  display: block;
  font-weight: 400;
  margin: 1px 0;
  padding: 10px 50px;
  text-align: center;
  text-decoration: none;
  text-shadow: 0 0 5px #444;
  pointer-events: none;
}

/* ==========================================================================
Navbar styles
========================================================================== */
.jh-navbar {
  background-color: #fff;
  padding: 0.2em 1em;
  border-bottom: 1px solid #e6e4e4;
  height: 55px;
}
.jh-navbar .profile-image {
  margin: -10px 0px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
.jh-navbar .dropdown-item.active,
.jh-navbar .dropdown-item.active:focus,
.jh-navbar .dropdown-item.active:hover {
  background-color: #353d47;
}
.jh-navbar .dropdown-toggle::after {
  margin-left: 0.15em;
}
.jh-navbar ul.navbar-nav {
  padding: 0.5em;
}
.jh-navbar ul.navbar-nav .nav-item {
  margin-left: 0.2rem;
}
.jh-navbar a.nav-link {
  font-weight: 400;
  color: #4a5568;
}
.jh-navbar a.nav-link > span {
  margin-left: 5px;
}
.jh-navbar .jh-navbar-toggler {
  color: #ccc;
  font-size: 1.5em;
  padding: 10px;
}
.jh-navbar .jh-navbar-toggler:hover {
  color: #fff;
}

.navbar-brand {
  overflow: hidden;
}

.jh-navbar .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-version {
  font-size: 0.65em;
  color: #bbb;
  padding: 0 0 0 10px;
}

.brand-logo:hover {
  text-decoration: none;
}
.brand-logo .brand-icon {
  width: auto;
  display: inline-block;
}

.brand-title {
  font-size: 1.25rem;
  margin-left: 0.25rem;
  color: #fff;
}
.brand-title:hover {
  color: #cccccc;
  text-decoration: none;
}

.loading-bar {
  height: 3px;
  background-color: #009cd8;
  position: absolute;
  top: 0px;
  z-index: 1031;
}

.avatar {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss"],"names":[],"mappings":"AAKA;;4EAAA;AAGA;EACE,sCAAA;EACA,YAAA;EAKA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;AAJF;AAKE;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;AAHJ;;AAOA;;4EAAA;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;AAJF;AAKE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAHJ;AAKE;;;EAGE,yBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,cAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAKE;EACE,gBAAA;EACA,cA/DgB;AA4DpB;AAII;EACE,gBAAA;AAFN;AAKE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AAHJ;AAII;EACE,WAAA;AAFN;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,eAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WA3FuB;EA4FvB,mBAAA;AAHF;;AAOE;EACE,qBAAA;AAJJ;AAME;EACE,WAAA;EACA,qBAAA;AAJJ;;AAQA;EACE,kBAAA;EACA,oBAAA;EACA,WA7Ga;AAwGf;AAME;EACE,cA7GiB;EA8GjB,qBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;AALF;;AAOA;EACE,gBAAA;AAJF","sourcesContent":["$header-color: #fff;\n$header-color-secondary: #bbb;\n$header-color-hover: darken($header-color, 20%);\n\n$header-menu-color: #4a5568;\n/* ==========================================================================\nDevelopment Ribbon\n========================================================================== */\n.ribbon {\n  background-color: rgba(170, 0, 0, 0.5);\n  left: -3.5em;\n  -moz-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  overflow: hidden;\n  position: absolute;\n  top: 40px;\n  white-space: nowrap;\n  width: 15em;\n  z-index: 99999;\n  pointer-events: none;\n  opacity: 0.75;\n  a {\n    color: #fff;\n    display: block;\n    font-weight: 400;\n    margin: 1px 0;\n    padding: 10px 50px;\n    text-align: center;\n    text-decoration: none;\n    text-shadow: 0 0 5px #444;\n    pointer-events: none;\n  }\n}\n\n/* ==========================================================================\nNavbar styles\n========================================================================== */\n.jh-navbar {\n  background-color: #fff;\n  padding: 0.2em 1em;\n  border-bottom: 1px solid #e6e4e4;\n  height: 55px;\n  .profile-image {\n    margin: -10px 0px;\n    height: 40px;\n    width: 40px;\n    border-radius: 50%;\n  }\n  .dropdown-item.active,\n  .dropdown-item.active:focus,\n  .dropdown-item.active:hover {\n    background-color: #353d47;\n  }\n  .dropdown-toggle::after {\n    margin-left: 0.15em;\n  }\n  ul.navbar-nav {\n    padding: 0.5em;\n    .nav-item {\n      margin-left: 0.2rem;\n    }\n  }\n  a.nav-link {\n    font-weight: 400;\n    color: $header-menu-color;\n    > span {\n      margin-left: 5px;\n    }\n  }\n  .jh-navbar-toggler {\n    color: #ccc;\n    font-size: 1.5em;\n    padding: 10px;\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n.navbar-brand {\n  overflow: hidden;\n}\n\n.jh-navbar .navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-version {\n  font-size: 0.65em;\n  color: $header-color-secondary;\n  padding: 0 0 0 10px;\n}\n\n.brand-logo {\n  &:hover {\n    text-decoration: none;\n  }\n  .brand-icon {\n    width: auto;\n    display: inline-block;\n  }\n}\n\n.brand-title {\n  font-size: 1.25rem;\n  margin-left: 0.25rem;\n  color: $header-color;\n  &:hover {\n    color: $header-color-hover;\n    text-decoration: none;\n  }\n}\n\n.loading-bar {\n  height: 3px;\n  background-color: #009cd8;\n  position: absolute;\n  top: 0px;\n  z-index: 1031;\n}\n.avatar {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
